import {Select, SelectProps} from "@mantine/core";
import USStates from "./US.states";

interface Props extends Omit<SelectProps, "data"> {

}

function State(props: Props) {

    function serializeStates() {
        return Object.keys(USStates).map((key) => ({value: key, label: USStates[key]}))
    }

    return (
        <Select {...props} data={serializeStates()}/>
    )

}

export default State;